import React from 'react';
import styled from 'styled-components';

import Table from 'components/Table';
import { genericDataColumns } from '../helpers';

const ProcessHistory = ({ isLoading, history }) => {
  const columns = genericDataColumns(history);
  if (isLoading) return null;

  return (
    <StyledTable
      size="small"
      loading={isLoading}
      dataSource={history}
      columns={columns}
      rowKey="revision"
    >
      {/* <Table.Column type="datetime" title="Date Time" dataIndex="dt_datetime" />
      <Table.Column type="text" title="People Active" width="70px" dataIndex="people_active" />
      <Table.Column type="text" title="People Tagged" width="70px" dataIndex="people_tagged" />

      <Table.Column type="number" title="Boxes" dataIndex="unloaded_boxes" />
      <Table.Column type="number" title="Unloaded" dataIndex="unloaded_percent" render={val => Math.round(val * 10000) / 100 + '%'} />
      <Table.Column type="number" title="Unloaded Forcast" dataIndex="unloaded_percent_forecast" render={val => Math.round(val * 10000) / 100 + '%'} />
      
      <Table.Column type="number" title="Avg CPM" dataIndex="avg_cpm" precision={3} />
      <Table.Column type="number" title="Last 5min CPM" dataIndex="last_5min_rate_cpm" precision={3} />
      
      <Table.Column type="number" title="Last Depth" dataIndex="last_depth" precision={3} />
      <Table.Column type="number" title="Depth Raw" dataIndex="last_depth_raw" precision={3} />
      <Table.Column type="number" title="Depth Adjusted" dataIndex="last_depth_adjusted" precision={3} />
      <Table.Column type="number" title="Depth Pred MM" dataIndex="last_depth_predicted_mm" precision={3} />
      <Table.Column type="number" title="Depth Pred Avg" dataIndex="last_depth_avg_pred" precision={3} />

      <Table.Column type="number" title="Labor Man Mins" dataIndex="tot_labor_man_mins" precision={3} />
      <Table.Column type="number" title="Cart Mins" dataIndex="tot_cart_mins" precision={3} />
      <Table.Column type="number" title="Last 5min Man Min" dataIndex="man_min_rate_last5_mins" precision={3} />
      <Table.Column type="number" title="Seg only 10min" dataIndex="seg_only_last_10min" precision={3} /> */}
    </StyledTable>
  );
};

const StyledTable = styled(Table)`
  & .ant-table {
    overflow: auto;
  }
`;

export default ProcessHistory;
